<template>
    <ul class="dropdown-menu overflow-visible">
        <li
            v-for="option in Object.values(menuOptions)"
            v-bind:key="option.id">
            <div
                v-if="showOption(option, rowObject)"
                class="dropdown-item p-0">
                <!-- TODO-TCM(#41362): Can't figure out how to get the button to not interact at all when it's disabled -->
                <!-- TODO-TCM(#41362): Figure out how to actually implement primary button styling, or CPAdmin option styling -->
                <!-- TODO-TCM(#41362): how do we show pc-alerts in the context menu? Success modal? -->
                <pc-button
                    v-bind:class="menuOptionClasses"
                    v-bind:data-test-role="option.dataTestRole"
                    v-bind:disabled="disableOption(option, rowObject)"
                    v-on:click="option.action(rowObject, 'contextMenu')">
                    <pc-bs-icon
                        v-if="option.iconName"
                        class="text-primary"
                        v-bind:name="option.iconName" />
                    &nbsp;
                    {{ getDisplayText(option.text, rowObject) }}
                </pc-button>
            </div>
        </li>
    </ul>
</template>

<script setup>
    defineProps({
        menuOptions: {
            type: Object,
            required: true
        },
        rowObject: {
            type: Object,
            required: true
        }
    });

    const menuOptionClasses = {
        "dropdown-item": true,
        "bg-transparent": true,
        "border-0": true,
        "d-flex": true,
        "align-items-center": true,
        "justify-content-start": true
    };

    function getDisplayText(text, rowObject) {
        return typeof text === "function" ? text(rowObject) : text;
    }

    function showOption(option, rowObject) {
        // If the conditional rendering property is not set, always show
        if (!option.hasOwnProperty("visible")) {
            return true;
        }

        return typeof option.visible === "function" ? option.visible(rowObject) : option.visible;
    }

    function disableOption(option, rowObject) {
        if (!option.hasOwnProperty("disabled")) {
            return false;
        }

        return typeof option.disabled === "function" ? option.disabled(rowObject) : option.disabled;
    }
</script>
